import { OffersState } from 'src/feature-app/redux/reducer';
import { CarlineWithOffers, Offer } from 'src';
import { fetchOffers } from './';
import { OffersFaContent } from 'src/feature-app/hooks/use-fa-content';
import { getDataServiceConfig } from 'src/feature-app';
import { ServiceConfigurationV1 } from '@volkswagen-onehub/service-config-provider';
import { getDataUrl, isPrivate } from './get-data-url';
import { Promociones } from 'src/types';

const offerHasPromoActive = (promociones: Promociones[], promo: string) => promociones.find(promocion => promocion.name === promo);
const offerActiva = (offer: Offer) => offer.prioridad > 0 && offer.activo === 1;
const offerHasOcasion = (offer: Offer) => offer.activoOcasion === 1 && offer.ocasion;

const filterCarlinesFromFaContent = (carlines: CarlineWithOffers[], faContentCarlines: number[]) => {
  return faContentCarlines.map((carlineCode) =>
    carlines.find((carline) => carline.code == carlineCode)
  );
};


export const handleOffers = async (
  faContent: OffersFaContent,
  dataService?: ServiceConfigurationV1
): Promise<OffersState | void | { offers: CarlineWithOffers[]; }> => {

  return fetchOffers(dataService)
    .then((carlines: CarlineWithOffers[]) => {
      let filteredCarlines = carlines.filter((carline: CarlineWithOffers) => {
        if (carline.activo && carline.activoOffers && carline.ofertas && carline.ofertas.length > 0) {
          return carline;
        }
      });

      if (faContent?.promocion) {
        let carlinesWithPromo = filteredCarlines.map((carline) => {
          carline.ofertas = carline.ofertas.map((offer) => {
            const promo = offerHasPromoActive(offer.promociones, faContent.promocion);
            if (promo && offerActiva(offer)) {
              return offer;
            }
          }).filter(offer => offer !== undefined);
          return carline;
        }).filter((carline) => carline.ofertas.length > 0);

        if (faContent?.carlines?.length > 0) {
          carlinesWithPromo = filterCarlinesFromFaContent(carlinesWithPromo, faContent.carlines);
        }

        return {
          offers: carlinesWithPromo,
        };

      }

      if (faContent?.filtroFinanciacion !== 'Ninguno') {
        console.log('filtroFinanciacion', faContent?.filtroFinanciacion);
        const filtroFinanciacion = faContent?.filtroFinanciacion;
        filteredCarlines = filteredCarlines.map((carline) => {
          carline.ofertas = carline.ofertas.map((offer) => {
            if (offerActiva(offer)) {
              if (filtroFinanciacion === 'My renting') {
                if (offer.myRenting === 1) {
                  return offer;
                }
              } else if (filtroFinanciacion === 'My way') {
                if (offer.myWay.activo === 1) {
                  return offer;
                }
              }
            }
          }).filter(offer => offer !== undefined);
          return carline;
        }
        ).filter((carline) => carline.ofertas.length > 0);
      }

      if (faContent && faContent.carlines.length > 0) {
        filteredCarlines = filterCarlinesFromFaContent(carlines, faContent.carlines);
      }

      const filteredOffers = filteredCarlines
        .map((carline: CarlineWithOffers) => {
          carline.ofertas = carline.ofertas
            .filter((offer: Offer) => {
              if (offerActiva(offer)) {
                return offer;
              }
            })
            .sort((a: Offer, b: Offer) => {
              return b.prioridad - a.prioridad;
            });

          return carline;
        })
        .filter((carline) => carline.ofertas.length > 0);

      // Orden según marca
      const carlinesPrivate = filteredOffers.filter((carline) => carline.brand === 'V');
      const carlinesCommercial = filteredOffers.filter((carline) => carline.brand === 'N');

      let sortedCarlines = [];
      let isPrivatePage;

      if (dataService) {
        //SSR
        isPrivatePage = isPrivate(dataService);
      } else {
        isPrivatePage = isPrivate(getDataServiceConfig());
      }

      if (isPrivatePage) {
        sortedCarlines = [...carlinesPrivate, ...carlinesCommercial];
      } else {
        sortedCarlines = [...carlinesCommercial, ...carlinesPrivate];
      }

      const finalResult: OffersState = {
        offers: sortedCarlines,
      };

      return finalResult;
    })
    .catch((error) => {
      console.error('Error during offers fetch', error);
    });
};
